// 画面進入で .is-inview を付与しフェードアップ表示する（製品カルーセルはmarqueeのため対象外）
const SELECTOR =
  '.lp-reco__item, .lp-problem-card, .lp-solution__row, ' +
  '.lp-feature, .lp-compare__row, .lp-pricecard, .lp-faq__item';

function setup() {
  const els = document.querySelectorAll(SELECTOR);
  if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('is-inview'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' },
  );
  els.forEach((el) => io.observe(el));
}

// よくある質問のトグルを高さアニメで滑らかに開閉する（ネイティブ<details>は瞬時に開くため）。
function initFaq() {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.lp-faq__item').forEach((details) => {
    const summary = details.querySelector('.lp-faq__q');
    const ans = details.querySelector('.lp-faq__a');
    if (!summary || !ans) return;

    summary.addEventListener('click', (e) => {
      if (reduce) return; // reduced-motion 時はネイティブの即時トグルに任せる
      e.preventDefault();
      if (details.dataset.animating) return;
      details.dataset.animating = '1';

      const closing = details.open;
      if (!closing) details.open = true; // 開くときは先に展開して全高を測る
      const full = ans.scrollHeight;
      ans.style.height = `${closing ? full : 0}px`;
      ans.getBoundingClientRect(); // 強制リフローで開始値を確定
      ans.style.height = `${closing ? 0 : full}px`;

      ans.addEventListener('transitionend', function done(ev) {
        if (ev.propertyName !== 'height') return;
        ans.removeEventListener('transitionend', done);
        ans.style.height = '';
        if (closing) details.open = false;
        delete details.dataset.animating;
      });
    });
  });
}

// SPメニューの開閉演出（開く=青→白ワイプ、閉じる=フェード）。
// JS無効時はCSSの:targetで即時開閉するフォールバックが効く。
function initMenu() {
  const menu = document.getElementById('lp-menu');
  const burger = document.querySelector('.lp-burger');
  if (!menu || !burger) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const open = () => {
    menu.classList.remove('is-closing');
    menu.classList.add('is-open');
  };
  const close = () => {
    if (!menu.classList.contains('is-open')) return;
    menu.classList.remove('is-open');
    if (reduce) return; // reduced-motion時はフェードせず即閉じ
    menu.classList.add('is-closing');
  };

  menu.addEventListener('animationend', (e) => {
    if (e.target === menu && e.animationName === 'lp-menu-fade') {
      menu.classList.remove('is-closing');
    }
  });

  burger.addEventListener('click', (e) => {
    e.preventDefault();
    open();
  });
  const closeBtn = menu.querySelector('.lp-mobile-nav__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault(); // 閉じるだけ（#topへのスクロールはしない）
      close();
    });
  }
  // ナビ項目はデフォルトのアンカー遷移を残したまま閉じる
  menu.querySelectorAll('.lp-mobile-nav__links a').forEach((a) => {
    a.addEventListener('click', () => close());
  });
}

function init() {
  setup();
  initFaq();
  initMenu();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
